import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../Assets/Images/VIZEdi-322x80-Tm.png';
import './CSS/Navbar.css';

const Navbar: React.FC = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <nav className="navbar">
            <Link to="/">
                <img className="navbar-logo" src={logo} alt="Home" />
            </Link>

            {/* Burger icon for smaller screens */}
            <div className="burger" onClick={toggleMenu}>
                <div></div>
                <div></div>
                <div></div>
            </div>

            {/* Navbar links */}
            <ul className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
                <span className="link">
                    <Link to="/about">About Us</Link>
                </span>
                <span className="link">
                    <Link to="/subscription-pricing">Subscriptions/Pricing</Link>
                </span>
                <span className="link">
                    <Link to="/enterprise-solutions">Enterprise Solutions</Link>
                </span>
                <span className="link">
                    <Link to="/customer-support">Contact Us</Link>
                </span>
                {/* Get Started button inside the collapsible menu */}
                <li className="login-button">
                    <Link to="/login">
                        <button>Get Started</button>
                    </Link>
                </li>
            </ul>
        </nav>
    );
};

export default Navbar;
